import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const AddSpecialContent = (props) => {
  const [loading, setLoading] = useState(false);

  const handleSpecialContentClose = async () => {
    setLoading(true);

    if (props.specialContent.length > 0) {
      var body = {
        id: props.clientsData.id,
        special_client: "TAK",
        why_special: props.specialContent,
      };

      await fetch("https://apidevkppp.ftpeople.pl/setSpecialClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Oznaczono klienta szczególnego",
        props.clientsData.id
      );

      MySwal.fire({
        icon: "success",
        title: "Oznaczono",
        text: "klienta szczególnego",
      }).then(async (result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Uzupełnij przyczynę oznaczenia klienta szczególnego",
      }).then(async (result) => {});
    }
  };

  return (
    <div className="mainContainerAddClientContact">
      <>
        {loading ? (
          <LoadingPopup id={"popUpLoading"} />
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <div id="addPaymentIC" className="inputContainer">
              <div className="inputBox">
                <div className="inputCol_1">
                  <label>Przyczyny oznaczenia klienta szczególnego</label>
                  <textarea
                    spellCheck="false"
                    className="textAreaNote"
                    type="text"
                    id="url"
                    name="url"
                    value={props.specialContent}
                    onChange={props.handleSetSpecialContent}
                  />
                </div>
              </div>

              <div className="saveBoxAP">
                <button
                  className="paymentMenuButton"
                  onClick={handleSpecialContentClose}
                >
                  zapisz
                </button>
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
};

export default AddSpecialContent;
